// Brand assets & site content for Relumia — JAKS Pharma Private Limited (JPPL)

export const ASSETS = {
  productHero:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_c2aeebc3-3e7b-4dd4-a7b1-821e849b9004/artifacts/uhfbq3kt_WhatsApp%20Image%202026-06-19%20at%2017.54.08.jpeg",
  logo: "/jaks-logo.png",
  wordmark: "/relumia-logo.png",
  texture:
    "https://images.unsplash.com/photo-1645785328791-64e8ff28edcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcGElMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDI4MDE2NHww&ixlib=rb-4.1.0&q=85",
  lab: "https://images.unsplash.com/photo-1658387575539-f433c725a086?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxzY2llbnRpZmljJTIwbGFib3JhdG9yeSUyMGNvc21ldGljfGVufDB8fHx8MTc4NDI4MDE2M3ww&ixlib=rb-4.1.0&q=85",
  glow: "https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80",
};

export const NAV = [
  { label: "Brand", href: "#brand" },
  { label: "Glutathione", href: "#glutathione" },
  { label: "How It Works", href: "#how" },
  { label: "OPITAC™", href: "#opitac" },
  { label: "Why Relumia", href: "#why" },
  { label: "Authenticity", href: "#authenticity" },
  { label: "Enquire", href: "#contact" },
];

export const BATCHES = [
  { batch: "PN26G001A", exp: "Dec 2027", mrp: "1950", pack: "30 Tablets (3×10)" },
  { batch: "PN26C006", exp: "Aug 2027", mrp: "1950", pack: "30 Tablets (3×10)" },
];

export const FAQS = [
  {
    q: "What is Relumia?",
    a: "Relumia is a dermatologist-formulated skin-lightening tablet by JAKS Pharma. It combines L-Glutathione (reduced + Optiac), Vitamin C, Vitamin D3, Zinc Sulphate and Curcumin to support brighter, even-toned and youthful skin from within.",
  },
  {
    q: "How does glutathione lighten skin?",
    a: "Glutathione is the body's master antioxidant. It inhibits tyrosinase, the enzyme that drives melanin production, shifting the skin toward lighter pheomelanin while neutralising free radicals that cause dullness and pigmentation.",
  },
  {
    q: "How do I take Relumia?",
    a: "One tablet daily after a meal, or as directed by your physician. Best results appear with consistent use over 8–12 weeks alongside sun protection.",
  },
  {
    q: "Is it safe?",
    a: "Relumia is dermatologist-formulated with pharmaceutical-grade ingredients manufactured to strict quality standards. Consult your physician if pregnant, nursing, or on medication.",
  },
  {
    q: "When will I see results?",
    a: "Most users notice a more radiant, even tone within 6–8 weeks. Glutathione works cumulatively, so continued use sustains and deepens the glow.",
  },
];

export const CONTACT = {
  company: "JAKS Pharma Private Limited (JPPL)",
  brand: "RELUMIA",
  email: "customercare@jakspharma.com",
  phone: "022 6971 9792",
  whatsapp: "+91 84240 65123",
  whatsappUrl: "https://wa.me/918424065123",
  address: "Level 4, Dynasty, A Wing, Andheri Kurla Road, Mumbai, Maharashtra 400059",
  website: "www.jakspharma.com",
  domain: "www.relumia.in",
};

export const OPITAC = {
  intro:
    "At the heart of Relumia is OPITAC™ Glutathione Reduced — a premium Japanese glutathione produced by KOHJIN Life Sciences, a Mitsubishi Corporation Life Sciences company. Relumia is then crafted in India at a world-class WHO-GMP certified facility.",
  whoGmp: "Manufactured at a world-class WHO-GMP certified plant",
  edges: [
    ["Japanese OPITAC™", "Powered by OPITAC™ L-Glutathione Reduced, sourced from KOHJIN's GMP-certified facility in Oita, Japan."],
    ["Non-GMO fermentation", "The OPITAC™ actives are produced via a non-GMO torula yeast fermentation process — clean, natural and consistent."],
    ["World's only FDA GRAS", "OPITAC™ is the only glutathione in the world to hold U.S. FDA GRAS-notified status for safety."],
    ["Clinically proven absorption", "Peer-reviewed studies (from 2013, with Kyoto University) confirm intact oral absorption in the human body."],
  ],
};
